
import { Link } from 'react-router-dom';

const DonateSection = () => {
  return (
    <section className="py-32 bg-gradient-to-br from-[#E6007E] via-[#C8006B] to-[#E6007E] relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-['Poppins'] font-black text-6xl sm:text-7xl md:text-8xl text-white mb-8 leading-tight">
            Support Our Mission
          </h2>
          <p className="font-['Inter'] text-white text-2xl mb-12 leading-relaxed">
            Your contribution helps us provide free mentorship, workshops, and resources to Latina leaders across the country.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <Link
              to="/mas-academy"
              className="inline-block px-12 py-5 bg-[#111111] text-white font-['Poppins'] font-bold text-lg rounded-lg hover:bg-black transition-all duration-300 shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
            >
              Sponsor a Workshop
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DonateSection;
